/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function TextStyleFromJSON(json) {
    return TextStyleFromJSONTyped(json, false);
}
export function TextStyleFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'size': !exists(json, 'size') ? undefined : json['size'],
        'color': !exists(json, 'color') ? undefined : json['color'],
        'font': !exists(json, 'font') ? undefined : json['font'],
    };
}
export function TextStyleToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'size': value.size,
        'color': value.color,
        'font': value.font,
    };
}
//# sourceMappingURL=TextStyle.js.map